import { makeStyles } from "@material-ui/core/styles";
import { toolbarHeight } from "components/app/Styles";
import theme from "theme";
const filterContainerHeight = 73;

const useStyles = makeStyles({
    "@global": {
      html: {
        height: "100%",
      },
      body: {
        margin: "0",
        height: "100%",
        fontFamily: "Arial, sans-serif",
      },
    },
    filterContainer: {
        minHeight: filterContainerHeight,
        width: "100%",
        backgroundColor: '#E5E9EE',
        paddingLeft: 64,
        paddingRight: 64,
        boxShadow: '0px 3px 6px #00000029',
        position: 'absolute',
        cursor: 'pointer',
        zIndex: 1,
    },
    expandBtn: {
        background: '#FFFFFF',
        position: 'absolute',
        bottom: -10,
        left: `calc(50vw - 35px)`,
        maxHeight: 25,
        paddingLeft: 8,
        paddingRight: 8,
        boxShadow: '0px 3px 6px #00000029',
        border: 0,
        color: '#757575',
        fontSize: 14,
        '& .MuiButton-startIcon': {
            marginRight: 0
        },
        '&:hover': {
            background: '#FFFFFF'
        }
    },
    applyBtn: {
        marginTop: 24,
        textTransform: 'uppercase',

    },
    filterSelect: {
        borderRadius: 0,
        minWidth: 200,
        marginTop: 16,
        marginBottom: 8,
        marginRight: 16,
        height: 61,
        '& .MuiOutlinedInput-input': {
            padding: 8,
            fontSize: 16,
        },
        '& .MuiInput-formControl': {
            marginTop: 24,
            paddingTop: 4,
            marginBottom: 8,
            border: '1px solid #ccc',
        },
        '& .MuiInput-underline:before': {
            borderBottom: 0,
            '&:hover': {
                borderBottom: 0
            }
        },
        '& .MuiSelect-icon': {
            marginRight: 8
        },
        '& .MuiSelect-select': {
            paddingLeft: 16,
            marginBottom: 4
        }
    },
    filterSelectLabel: {
        marginBottom: 4
    },
    chips: {
        display: 'flex',
        
        alignItems: 'center',
    },
    chip: {
        color: '#707070',
        paddingTop: 18,
        paddingBottom: 18,
        paddingLeft: 25,
        paddingRight: 25,
        borderRadius: 40,
        fontSize: 12,
        marginRight: 18,
        '& .MuiChip-label': {
            padding: 0
        }
    },
    mainView: {
        position: 'fixed',
        top: `calc(${toolbarHeight}px + ${filterContainerHeight}px)`
    },
    chartTogglebar: {
        width: 68,
        display: 'flex',
        flexDirection: 'row',
        height: `calc(100vh - ${toolbarHeight}px - ${filterContainerHeight}px)`,
        backgroundColor: '#323232',
        boxShadow: "0px 3px 6px #00000080",
    },
    chartToggleIcon: {
        width: 26,
        height: 15,
        paddingTop: 36,
        paddingBottom: 36,
        paddingLeft: 21,
        paddingRight: 21,
        cursor: 'pointer'
    },
    chartTabs: {
        display: 'inline-flex',
        alignItems: 'start',
        '& .MuiTabs-indicator': {
            display: 'none'
        },
        '& .Mui-selected': {
            background: '#718CD4',
            '&:hover': {
                background: '#718CD4',
            }
        }
    },
    chartTab: {
        minWidth: 68,
        marginBottom: 8,
        paddingBottom: 0,
        paddingTop: 0,
        backgroundColor: '#1E1E1E',
        opacity: 1,
        marginTop: 0,
        '&:hover': {
            backgroundColor: '#4B5A84'
        },
    },
    chartIconPlaceholder: {
        height: 120,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    },
    chartDrawer: {
        width: 390,
        position: 'absolute',
        zIndex: 100,
        top: 0,
        left: 68,
        height: `calc(100vh - ${toolbarHeight}px - ${filterContainerHeight}px)`,
        backgroundColor: '#F5F5F5',
        boxShadow: '0px 3px 6px #00000060',
    },
    chartHeader: {
        width: `100%`,
        paddingTop: 50,
        paddingBottom: 22,
        paddingLeft: 64,
    },
    chartHeaderTitle: {
        color: '#2352D0',
        fontSize: 30,
        fontWeight: 'bold',
    },
    chartHeaderSubtitle: {
        color: '#000',
        fontSize: 18,
        fontWeight: 'bold',
    },
    chartHeaderTitleResponsive: {
        color: '#2352D0',
        fontSize: 16,
        fontWeight: 'bold',
    },
    chartHeaderSubtitleResponsive: {
        color: '#000',
        fontSize: 12,
        fontWeight: 'bold',
    },
    chartItem: {
        height: 120,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        paddingLeft: 32,
        paddingRight: 32,
        background: '#E9E9EB',
        marginBottom: 8,
    },
    chartItemTitle: {
        font: 'normal normal bold 18px/22px Arial',
        marginBottom: 8
    },
    chartItemDesc: {
        fontSize: 14,
    },
    chooseText: {
        fontSize: 30,
        fontWeight: 'bold',
        color: '#212121',
        flexGrow: 1
    },
    aboutTogglebar: {
        width: 68,
        display: 'flex',
        height: `calc(100vh - ${toolbarHeight}px - ${filterContainerHeight}px)`,
        background: '#FFFFFF',
        boxShadow: '0px 3px 6px #00000029',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
        position: 'relative'
    },
    aboutToggleIcon: {
        width: 37,
        height: 27,
    },
    aboutDrawer: {
        width: 345,
        background: '#FFFFFF',
        boxShadow: '0px 3px 6px #00000029',
        // height: `calc(100vh - ${toolbarHeight}px - ${filterContainerHeight}px)`,
        overflow: 'auto',
        position: 'relative', 
        height: '100vh', // enable scrolling
    },
    metricTitle: {
        marginTop: 16,
    },
    metricValue: {
        color: '#000000',
        fontSize: 24,
        fontWeight: 'bold',
        marginBottom: 40
    },
    closeBtn: {
        position: 'relative',
        left: '93%',
    },
    chartView: {
        display: 'flex',
        flexDirection: 'column',
        flexGrow: 1,
        height: `calc(100vh - ${toolbarHeight}px - ${filterContainerHeight}px)`,
        background: '#E5E9EE'
    },
    tabs: {
        flexBasis: 'auto',
        display: 'flex',
        justifyContent: 'center',
        alignContent: 'center',
        marginBottom: '2vh',
        marginTop: -20,
    },
    tabRoot: {
        '& .MuiTab-wrapper': {
            textTransform: 'uppercase'
        },
        '& .MuiTabs-indicator': {
            background: 'none',
        },
    },
    tabInactive: {
        background: '#FFFFFF',
        color: '#757575',
        minWidth: 'auto',
        minHeight: 'auto',
        padding: '10px 12px',
        opacity: 1,
        font: 'normal normal normal 12px/14px Arial',
        border: '0.5px solid #B8B8B8',
        '& .MuiTab-wrapper': {
            width: 'auto',
        },
        [theme.breakpoints.up('xl')]: {
            font: 'normal normal normal 16px/18px Arial',
        },
    },
    tabActive: {
        opacity: 1,
        background: '#EBF0FD',
        color: '#2352D0',
    },
    startingTab: {
        borderTopLeftRadius: 5,
        borderBottomLeftRadius: 5,
    },
    endingTab: {
        borderTopRightRadius: 5,
        borderBottomRightRadius: 5,
    },
    sectionTitle: {
        fontSize: 18,
        fontWeight: 'bold'
    },
    sectionContent: {
        marginTop: 8,
        marginBottom: 24
    },
    aboutBox: {
        height: '80%',
        overflow: 'auto',
    }
}, { index: 999 });

export default useStyles;